<template>
  <!--英文作文题弹框 -->
  <el-dialog
    class="write-en-dialog dialog"
    title="作文(英)"
    width="550px"
    :visible="value"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="$emit('input', false)"
    append-to-body
  >
    <el-form
      class="demo-Form"
      :model="formData"
      :rules="rulesFrom"
      label-width="100px"
      ref="formData"
    >
      <el-form-item label="大题题号：" prop="th">
        <el-select v-model="formData.th" placeholder="请选择" size="small">
          <el-option v-for="item in ths" :key="'th'+item" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="limit-title" label="题目名称：" prop="name">
        <el-input
          class="topic_name"
          v-model="formData.name"
          type="text"
          placeholder="请输入内容"
          maxlength="27"
          show-word-limit
          size="small"
        ></el-input>
      </el-form-item>

      <div>
        <el-form-item label="小题题号：" prop="start">
          <el-input-number v-model="formData.start" :controls="false" size="small" :min="1" :step="1" :step-strictly="true"></el-input-number>
        </el-form-item>
      </div>

      <div>
        <el-form-item :label="'行\xa0\xa0\xa0\xa0\xa0\xa0数：'" prop="rowCount">
          <el-input-number
            :min="1"
            v-model="formData.rowCount"
            :controls="false"
            size="small"
            :max="50"
            :step="1"
            :step-strictly="true"
          ></el-input-number>
        </el-form-item>
      </div>

      <div>
        <el-form-item :label="'分\xa0\xa0\xa0\xa0\xa0\xa0值：'" prop="totalScore">
          <el-input-number v-model="formData.totalScore" :controls="false" size="small"  
            :precision="2"></el-input-number>
          <span>分</span>
        </el-form-item>
      </div>
    </el-form>

    <!--<div class="dialog-cont">
      <el-button type="text" @click="clearList(true)">清空列表</el-button>
      <div class="dialog-list">
        <el-table :data="formData.list" style="width: 100%">
          <el-table-column label="题号">
            <template slot-scope="scope">{{scope.row.tihao}}</template>
          </el-table-column>

          <el-table-column label="分值">
            <template slot-scope="scope">
              <el-input v-model="scope.row.fenshuo" size="small"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" style="text-align:center">
            <template slot-scope="scope">
              <el-button type="text" @click="clearList(false,scope)" icon="el-icon-delete"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>-->

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogClose">取 消</el-button>
      <el-button type="primary" @click="dialogSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { WriteEnModel } from "./WriteEn.model";
import { initTopicBoxMixins } from '@/mixins/initTopicBoxFormData.mixins';

export default {
  name: "WriteEn",
  props: ["value", "type", "subject"],
  mixins: [initTopicBoxMixins],
  computed: {
    ...mapState("cardMake", {
      answerSheet: (state) => state.answerSheet,
      topicTh: (state) => state.answerSheettopicTh,
      pageCellSize: (state) => state.pageCellSize,
      isBoxEdit: (state) => state.isBoxEdit,
      allIndex: (state) => state.allIndex,
    }),
    ...mapState("card", {
      ths: (state) => state.THS,
    }),
  },

  data() {
    var tihaoR = (rule, value, callback) => {
      let validV = new RegExp("^([1-9]\\d{0,}\\.){0,2}[1-9]\\d{0,}$");
      if (!value) {
        callback(new Error("必填"));
      } else if (!validV.test(value)) {
        callback(new Error("请正确填写"));
      } else {
        callback();
      }
    };
    return {
      place: "&nbsp;",
      loading: true,
      formData: new WriteEnModel(),
      rulesFrom: {
        th: [{ required: true, message: "必填", trigger: "blur" }],
        name: [{ required: true, message: "必填", trigger: "blur" }],
        start: [
          { required: true, message: "必填", trigger: "blur" },
          { validator: tihaoR, trigger: "blur" },
        ],
        totalScore: [{ required: true, message: "必填", trigger: "blur" }],
        rowCount: [{ required: true, message: "必填", trigger: "blur" }],
      },
    };
  },
  created() {},
  mounted() {},
  methods: {
    createItems() {}, //添加小题
    dialogClose() {
      if (this.subject) {
        this.subject.oldSubject =
          this.subject && JSON.parse(JSON.stringify(this.subject));
      }
      this.$emit("input", false);
    },
    dialogSubmit() {
      if (this.submitDisabled) {
        return false;
      }
      this.submitDisabled = true;
      let timer = setTimeout(() => {
        this.submitDisabled = false;
        clearTimeout(timer);
      }, 500);
      this.$refs["formData"].validate((valid) => {
        if (!valid) return;
        // createItem
        this.formData = new WriteEnModel(this.formData);
        this.$emit("submit-write", this.formData);
        if (this.subject) {
          this.subject.oldSubject =
            this.subject && JSON.parse(JSON.stringify(this.subject));
        }
      });
    },
  },
  watch: {
    value: {
      //handler:'test',
      handler(val) {
        if (val) {
          if (this.subject) {
            this.subject.oldSubject =
              this.subject && JSON.parse(JSON.stringify(this.subject));
          }
          this.subject
            ? (this.formData = new WriteEnModel(this.subject.oldSubject))
            : (this.formData = new WriteEnModel(this.type));
            !this.subject && this.clearHistoryTopicFormData()
        }
      },
      immediate: true,
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
